import './MultipleSelectQuiz.css';
import questionIcon from '../images/question.png';
const MultipleSelectQuiz = ({
  question,
  options = [],
  selectedAnswers = [],
  isAnswerChecked,
  onToggleAnswer,
}) => {
  if (!question) {
    return null;
  }

  const correctAnswers = Array.isArray(question.correctAnswer)
    ? question.correctAnswer
    : [];

  const handleOptionClick = (option) => {
    if (isAnswerChecked) {
      return;
    }

    onToggleAnswer?.(option);
  };

  return (
    <div className="quiz-content-scroll-bc multiple-select-scroll-container">
      <div className="explanation-lesoon-container-bc">
        <div className="title-simple-select-align">
           <img
                    src={questionIcon}
                    alt="Question"
                    className="multiple-select-question-icon"
                  />
         
            <div className="question-text-bc-multiple">
                 
              <p>{question.question}</p>
            </div>
         
        </div>

        <div className="multiple-answer-lessons-bc">
          {options.map((option, index) => {
            const isSelected = selectedAnswers.includes(option);
            const isCorrect = correctAnswers.includes(option);

            let checkboxClass = 'check-box-multiple-answer-bc';

            if (isAnswerChecked) {
              if (isCorrect) {
                checkboxClass = 'checkbox-correct';
              } else if (isSelected && !isCorrect) {
                checkboxClass = 'checkbox-incorrect';
              }
            }

            const optionStateClass = isAnswerChecked
              ? isCorrect
                ? 'border-correct'
                : isSelected
                  ? 'border-incorrect'
                  : ''
              : isSelected
                ? 'border-selected'
                : '';

            return (
              <div
                key={`${String(option)}-${index}`}
                className={`align-multiple-items-bc ${optionStateClass}`}
                onClick={() => handleOptionClick(option)}
                role="checkbox"
                aria-checked={isSelected}
                tabIndex={isAnswerChecked ? -1 : 0}
                onKeyDown={(event) => {
                  if (
                    event.key === 'Enter' ||
                    event.key === ' '
                  ) {
                    event.preventDefault();
                    handleOptionClick(option);
                  }
                }}
              >
                <input
                  className={checkboxClass}
                  type="checkbox"
                  checked={isSelected}
                  readOnly
                />

                <span className="cursor-pointer">
                  {option}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MultipleSelectQuiz;